import { useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import Select from "react-select";

import moment from "moment";

const DailyLogsFilterModal = ({
  user,
  details,
  setDetails,
  tabIndex,
  checked,
  handleCheckedChange,
  handleFilter,
  clearFilter,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const { filterBy, employees, locations } = useStateContext();

  const [empOption, setEmpOption] = useState({});

  const currentDate = new Date();

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);

  const handleFromDateChange = (e) => {
    setFromDate(e.value);
    setDetails({
      ...details,
      formDate: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleToDateChange = (e) => {
    setToDate(e.value);
    setDetails({
      ...details,
      toDate: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleSelectChange = (e, type) => {
    // console.log(e.value);
    setDetails({
      ...details,
      [type]: e.value,
    });
  };

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>
            {user.role === "1" ? (
              <>
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Employee Name
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={empOption}
                    onChange={(e) => {
                      handleSelectChange(e, "empid");
                    }}
                    value={
                      Array.isArray(empOption)
                        ? empOption.filter(
                            (option) => option.value === details.empid
                          )
                        : null
                    }
                  />
                </div>
              </>
            ) : null}

            {tabIndex === 1 ? (
              <>
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    From Date
                  </label>
                  <div>
                    <Calendar
                      value={fromDate}
                      onChange={handleFromDateChange}
                      view="date"
                      dateFormat="dd, MM, yy"
                      style={{ width: "100%" }}
                      showIcon
                      maxDate={currentDate}
                      selectOtherMonths
                    />
                  </div>
                </div>
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    To Date
                  </label>
                  <div>
                    <Calendar
                      value={toDate}
                      onChange={handleToDateChange}
                      view="date"
                      dateFormat="dd, MM, yy"
                      style={{ width: "100%" }}
                      showIcon
                      maxDate={currentDate}
                      selectOtherMonths
                    />
                  </div>
                </div>
              </>
            ) : null}

            {user.role === "1" || user.role === "4"  ? (
              <>
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Location
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={locations}
                    onChange={(e) => {
                      handleSelectChange(e, "location");
                    }}
                    value={
                      Array.isArray(locations)
                        ? locations.filter(
                            (option) => option.value === details.location
                          )
                        : null
                    }
                  />
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Status
              </label>
              <div className="statusFilter-flex visible">
                {/* <div className="sort-flex">
                  <span className="status-filter outdoorDuty">
                    Outdoor Duty
                  </span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Outdoor Duty")}
                      onChange={handleCheckedChange("Outdoor Duty")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div> */}
                <div className="sort-flex">
                  <span className="status-filter lateMark">Late Mark</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Late Mark")}
                      onChange={handleCheckedChange("Late Mark")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter absent">Absent</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Absent")}
                      onChange={handleCheckedChange("Absent")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter absent">On Leave</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("OnLeave")}
                      onChange={handleCheckedChange("OnLeave")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                 <div className="sort-flex">
                  <span className="status-filter outdoorDuty">
                    Week Off
                  </span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Week Off")}
                      onChange={handleCheckedChange("Week Off")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter halfDay">Half Day</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Half Day")}
                      onChange={handleCheckedChange("Half Day")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter WFH">WFH</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("WFH")}
                      onChange={handleCheckedChange("WFH")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter present">Present</span>
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={checked.includes("Present")}
                      onChange={handleCheckedChange("Present")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyLogsFilterModal;
